"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    rpc: {},
    types: {
        Amount: 'i128',
        AmountOf: 'Amount',
        AuctionId: 'u64',
        AuctionIdOf: 'AuctionId',
        BalanceIdOf: 'Balance',
        MetaverseId: 'u64',
        FungibleTokenId: {
            _enum: {
                NativeToken: 'TokenId',
                FungibleToken: 'TokenId',
                DEXShare: '(TokenId, TokenId)',
                MiningResource: 'TokenId'
            }
        },
        CurrencyIdOf: 'FungibleTokenId',
        TradingPairStatus: {
            _enum: ['NotEnabled', 'Enabled']
        },
        TradingPair: '(FungibleTokenId,FungibleTokenId)',
        TokenId: 'u64',
        SpotId: 'u32',
        ItemId: {
            _enum: {
                NFT: 'AssetId',
                Spot: '(u64, MetaverseId)',
                Metaverse: 'MetaverseId',
                Block: 'u64'
            }
        },
        Address: "MultiAddress",
        LookupSource: "MultiAddress",
        AccountInfo: "AccountInfoWithTripleRefCount",
        AssetInfo: {
            owner: "AccountId",
            data: "AssetData",
        },
        AssetId: "u64",
        AssetData: {
            name: "Text",
            description: "Text",
            properties: "Text",
            supporters: "Vec<AccountId>",
        },
        AuctionItem: {
            itemId: "ItemId",
            recipient: "AccountId",
            initial_amount: "Balance",
            amount: "Balance",
            start_time: "u32",
            end_time: "u32",
            auction_type: "AuctionType",
        },
        AuctionInfo: {
            bid: "Option<(AccountId,Balance)>",
            start: "BlockNumber",
            end: "Option<BlockNumber>",
        },
        AuctionType: {
            _enum: ["Auction", "BuyNow"],
        },
        RentId: "u64",
        RentalInfo: {
            owner: "AccountId",
            start: "BlockNumber",
            end: "Option<BlockNumber>",
            price_per_block: "Balance",
        },
        CountryId: "u64",
        CollectionId: "u64",
        ClassId: "u32",
        ClassInfoOf: {
            metadata: "Vec<u8>",
            total_issuance: "TokenId",
            owner: "AccountId",
            data: "NftClassData",
        },
        TokenInfoOf: {
            metadata: "Vec<u8>",
            owner: "AccountId",
            data: "NftAssetData",
        },
        NftCollectionData: {
            name: "Vec<u8>",
            owner: "AccountId",
            properties: "Vec<u8>",
        },
        NftGroupCollectionData: {
            name: "Vec<u8>",
            properties: "Vec<u8>",
        },
        NftAssetData: {
            deposit: "Balance",
            name: "Vec<u8>",
            description: "Vec<u8>",
            properties: "Vec<u8>",
        },
        NftClassData: {
            deposit: "Balance",
            properties: "Vec<u8>",
            token_type: "TokenType",
            collection_type: "CollectionType",
            total_supply: "u64",
            initial_supply: "u64",
        },
        NetworkId: {
            _enum: {
                Any: "Null",
                Named: "Vec<u8>",
                Polkadot: "Null",
                Kusama: "Null",
            },
        },
        CollectionType: {
            _enum: ["Collectable", "Wearable", "Executable"],
        },
        CurrencyId: "SocialTokenCurrencyId",
        TokenSymbol: {
            _enum: ["NUUM", "AUSD", "ACA", "DOT"],
        },
        CountryCurrencyId: "u32",
        ChainId: {
            _enum: {
                RelayChain: "Null",
                ParaChain: "ParaId",
            },
        },
        XCurrencyId: {
            chain_id: "ChainId",
            currency_id: "CurrencyId",
        },
        GroupCollectionId: "u64",
        ClassIdOf: "ClassId",
        TokenIdOf: "TokenId",
        PoolId: "u32",
        SocialTokenCurrencyId: {
            _enum: {
                NativeToken: "TokenId",
                FungibleToken: "TokenId",
                DEXShare: "(TokenId, TokenId)",
                MiningResource: "TokenId"
            },
        },
        Country: {
            owner: "AccountId",
            metadata: "Text",
            currency_id: "SocialTokenCurrencyId",
        },
        Ticker: "Vec<u8>",
        Token: {
            ticker: "Ticker",
            total_supply: "Balance",
        },
        CountryFund: {
            vault: "AccountId",
            value: "u128",
            backing: "u128",
            currency_id: "SocialTokenCurrencyId",
        },
        LandId: "u64",
        BlindBoxId: "u64",
        BlindBoxType: {
            _enum: [
                "KSM",
                "NUUM",
                "MainnetNFTHat",
                "MainnetNFTJacket",
                "MainnetNFTPants",
                "MainnetNFTShoes",
                "CollectableNFT",
            ],
        },
        BlindBoxRewardItem: {
            recipient: "AccountId",
            amount: "u32",
            blindbox_type: "BlindBoxType",
        },
        TokenType: {
            _enum: ["Transferable", "BoundToAddress"],
        },
        ListingLevel: {
            _enum: {
                "Global": "Null",
                "Local": "CountryId"
            }
        },
        ResourceId: "[u8; 32]",
        VoteThreshold: {
            _enum: [
                "StandardQualifiedMajority",
                "TwoThirdsSupermajority",
                "ThreeFifthsSupermajority",
                "ReinforcedQualifiedMajority",
                "RelativeMajority"
            ]
        },
        ProposalId: "u64",
        ReferendumId: "u64",
        CountryParameter: {
            _enum: {
                "MaxProposals": "u8",
                "SetReferendumJury": "AccountId"
            }
        },
        PreimageStatus: {
            _enum: {
                Missing: "BlockNumber",
                Available: {
                    data: "Vec<u8>",
                    does_update_jury: "bool",
                    provider: "AccountId",
                    deposit: "Balance",
                    since: "BlockNumber",
                    expiry: "Option<BlockNumber>"
                }
            }
        },
        ReferendumParameters: {
            voting_threshold: "Option<VoteThreshold>",
            min_proposal_launch_period: "BlockNumber",
            voting_period: "BlockNumber",
            enactment_period: "BlockNumber",
            max_proposals_per_country: "u8"
        },
        Vote: {
            aye: "bool"
        },
        Tally: {
            ayes: "u32",
            nays: "u32",
            turnout: "u32"
        },
        VotingRecord: {
            votes: "Vec<(ReferendumId,Vote)>"
        },
        ProposalInfo: {
            proposed_by: "AccountId",
            hash: "Hash",
            description: "Vec<u8>",
            referendum_launch_block: "BlockNumber"
        },
        ReferendumStatus: {
            end: "BlockNumber",
            country: "CountryId",
            proposal: "ProposalId",
            tally: "Tally",
            threshold: "Option<VoteThreshold>"
        },
        RoundIndex: "u32",
        MetaverseMetadata: "Vec<u8>",
        VestingScheduleOf: 'VestingSchedule',
        VestingSchedule: {
            token: 'FungibleTokenId',
            start: 'BlockNumber',
            period: 'BlockNumber',
            periodCount: 'u32',
            perPeriod: 'Compact<Balance>'
        }
    },
    typesAlias: {
        auction: {
            CurrencyId: 'FungibleTokenId'
        }
    }
};
